import {all} from 'redux-saga/effects';

import {createFetchSagaLatest} from 'utils/sagas';

import {
  fetchIntegrationsStatus,
  fetchIntegrationsSetupInfo,
  fetchActionReportFieldChoices
} from 'sdk/statusPage';

import {
  fetchIntegrationsSetupInfo as fetchIntegrationsSetupInfoAction,
  fetchActionReportFieldChoices as fetchActionReportFieldChoicesAction,
  fetchIntegrationsStatus as fetchIntegrationsStatusAction
} from './';

function* statusPageSaga() {
  yield all([
    createFetchSagaLatest(
      fetchIntegrationsSetupInfoAction,
      fetchIntegrationsSetupInfo
    ),
    createFetchSagaLatest(
      fetchActionReportFieldChoicesAction,
      fetchActionReportFieldChoices
    ),
    createFetchSagaLatest(
      fetchIntegrationsStatusAction,
      fetchIntegrationsStatus
    )
  ]);
}

export default statusPageSaga;
